/* eslint-disable react-hooks/rules-of-hooks */
import { useCallback } from 'react';

const eligibilityChecks = {
    'WIDGT-AIND-QUANT-01': (dto) => {
        const hasObjectives = dto?.objectiveDTOs && dto.objectiveDTOs.length > 0;
        const isQuantitative = dto?.indicatorDTO?.indicatorDTOType === 'QUANTITATIVE';
        return hasObjectives && isQuantitative;
    },
    'WIDGT-AIND-QUANT-02': (dto) => {
        const hasObjectives = dto?.objectiveDTOs && dto.objectiveDTOs.length > 0;
        const isQuantitative = dto?.indicatorDTO?.indicatorDTOType === 'QUANTITATIVE';
        return hasObjectives && isQuantitative;
    },
};

export function use_AREA_INDICATOR_eligibilityHelper() {
    // Define the helpers inside the hook and memoize them
    const isTemplateEligible = useCallback((template, dto) => {
        const check = eligibilityChecks[template.acronym];
        return check ? check(dto) : false;
    }, []);

    const getApplicableTemplates = useCallback((templates, dto) => {
        return templates.filter(template => isTemplateEligible(template, dto));
    }, [isTemplateEligible]);

    return {
        isTemplateEligible,
        getApplicableTemplates,
    };
}